import { NAME } from "./constants";

const select = key => state => state.pages[NAME][key];

export const isLoading = select("isLoading");
export const getUserDetails = state => {
    return state.pages.userView.user
};